(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["the-darl-dynamic-content"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
        const allButtons = document.querySelectorAll('.dynamic-content-button');
        
        const contentItems = document.querySelectorAll('.content-item');

        allButtons.forEach(button => {
            button.addEventListener('click', (event) => {
                const currentButton = event.currentTarget;
                const targetId = currentButton.getAttribute('data-target');

                contentItems.forEach(item => {
                    item.classList.remove('visible');
                    item.classList.add('hidden-content');
                });

                const targetContent = document.getElementById(targetId);
                let isExpanded = false;
                if (targetContent) {
                    targetContent.classList.remove('hidden-content');
                    targetContent.classList.add('visible');
                    isExpanded = true;
                }

                allButtons.forEach(btn => {
                    btn.classList.remove('active');
                    btn.setAttribute('aria-expanded', 'false');
                });
                
                const relatedButtons = document.querySelectorAll(`[data-target="${targetId}"]`);
                
                relatedButtons.forEach(btn => {
                    btn.classList.add('active');
                    btn.setAttribute('aria-expanded', isExpanded); 
                });
            });
        });
        
        const initialButton = document.querySelector('.dynamic-content-button.active');
        if (initialButton) {
            initialButton.click();
        } else if (allButtons.length > 0) {
            allButtons[0].click();
        }
    });

  } catch(e) { console.error(e); }
})();
})();
